import React, { useRef } from 'react';
import { MessageType } from '../../../../../services/actor-messages';
import WorkspaceItemContext from '../../../../contexts/workspace/workspace-item-context';
import { useFlightWorker } from '../../../../hooks/use-flight-worker';
import { useSafeEffect } from '../../../../hooks/use-safe-effect';
import { useWorkspace, useWorkspaceView } from '../../hooks/use-view';

export function WorkspaceUdViewSync() {
    // The worker context only cares about some properties of the udview. Here we observer those pieces and and it to the worker
    // Ideally this would be moved into worker-client file
    const filters = useWorkspaceView((x) => x.plane.filter);
    const tags = useWorkspaceView((x) => x.plane.tag);
    const cityPair = useWorkspaceView((x) => x.plane.settings.cityPair);
    const context = React.useContext(WorkspaceItemContext);
    const viewLoading = useWorkspace((x) => x.viewLoading);
    // Keep track of the previous view loading flag, if the flags goes from true to value don't sent any events to the worker
    // Worker already received latest ud view
    const lastViewLoading = useRef(viewLoading);
    const worker = useFlightWorker();

    useSafeEffect(() => {
        if (!viewLoading && !lastViewLoading.current) {
            worker.actor.sendAsync({ type: MessageType.tagsChanged, data: { workspaceId: context.id, tags } });
        }
        lastViewLoading.current = viewLoading;
    }, [worker, tags, viewLoading]);

    useSafeEffect(() => {
        if (!viewLoading && !lastViewLoading.current) {
            worker.actor.sendAsync({ type: MessageType.filtersChanged, data: { workspaceId: context.id, filters } });
        }
        lastViewLoading.current = viewLoading;
    }, [worker, filters, viewLoading]);

    useSafeEffect(() => {
        if (!viewLoading && !lastViewLoading.current) {
            worker.actor.sendAsync({
                type: MessageType.cityPairSettingsChanged,
                data: { workspaceId: context.id, enabled: cityPair.show }
            });
        }
        lastViewLoading.current = viewLoading;
    }, [worker, cityPair, viewLoading]);

    return <></>;
}
